import React, { Component } from 'react';
import { connect } from 'react-redux';
import { API, Auth } from 'aws-amplify';
import { Button, Layout, Row, Steps, Input, InputNumber, Col, Spin, Select, Switch } from 'antd';
import { LeftOutlined } from '@ant-design/icons';

const { Header, Content } = Layout;
const ButtonGroup = Button.Group
const Step = Steps.Step;
const Option = Select.Option;
const { TextArea } = Input;


class Create extends Component {
    state = {
        loadingStepOne: false,
        loadingStepTwo: false,
        loadingCreate: false,
        currentStep: 0,
        hotels: [],
        items: [],
        itemNames: new Map(),
        selectedItems: [],
        tableItems: [],
        productName: '',
        productInstructions: '',
        productItemsQuantity: new Map(),
        productItemsEssential: new Map(),
        disableCreateButton: true
    };

    idToken = '';

    loadData() {
        this.setState({loadingStepOne: true});

        API.get('benackoAPI', '/items?companyId=' + this.props.companyId, {
                headers: {
                    Authorization: this.idToken
                }
            })
            .then( itemsRes => {
                var items = [];
                var itemNames = new Map();

                itemsRes.sort((a, b) => {return a.name > b.name});

                itemsRes.forEach( item => {
                    itemNames[item.id] = item.name;

                    items.push(<Option key={item.id}>{item.name}</Option>);
                });

                this.setState({
                    loadingStepOne: false,
                    items: items,
                    itemNames: itemNames
                });
            })
            .catch( errInventories => {
                console.log('Error loading inventories:', errInventories);
                this.setState({loadingStepOne: false});
            });
    }

    componentDidMount() {
        Auth.currentSession()
            .then( response => {
                this.idToken = response.idToken.jwtToken;

                this.loadData();
                this.setHotelsData();
            })
            .catch( error => {
                console.log(error);
            });
    }

    setHotelsData() {
        var hotelIds =  [];
        
        for (var i in this.props.hotels) {
            hotelIds.push({ id: i });
        }

        this.setState({hotels: hotelIds});
    }

    goBackHandler = () => {
        this.props.history.goBack();
    }

    setProductName = (name) => {
        const beautifiedName = name.target.value.trim().toLowerCase();
        this.setState({productName: beautifiedName});
    }

    setProductQuantity = (quantity, itemKey) => {
        var productItems = this.state.productItemsQuantity;
        productItems[itemKey] = quantity;

        this.setState({productItemsQuantity: productItems});
    }

    setEssential = (value, itemKey) => {
        var productItems = this.state.productItemsEssential;
        productItems[itemKey] = value;

        this.setState({productItemsEssential: productItems});
    }

    selectItemHandler = (value) => {
        this.setState({selectedItems: value});
    }

    goToSecondStep = async () => {
        this.setState({loadingStepTwo: true, loadingCreate: true});
        var itemsQuantities = new Map();
        var itemsEssentials = new Map();

        const items = this.state.selectedItems.map( item => {
            itemsQuantities[item] = 1;
            itemsEssentials[item] = true;

            return (
                <Row key={item} style={{width: '100%', marginTop: 10}}>
                    <Col span={6} offset={2}>{this.state.itemNames[item]}</Col>
                    <Col span={4}>
                        <InputNumber
                            key={item}
                            defaultValue="1"
                            step={1}
                            min={1}
                            onChange={ (quantity) => {
                                this.setProductQuantity(quantity, item);
                            }}
                        />
                    </Col>
                    <Col span={6}>
                        <Switch size="small" onChange={ (value) => {
                            this.setEssential(value, item);
                        }} defaultChecked />
                    </Col>
                </Row>
            );
        });
        
        this.setState({
            tableItems: items, 
            productItemsQuantity: itemsQuantities, 
            productItemsEssential: itemsEssentials, 
            currentStep: 1, 
            loadingStepTwo: false, 
            loadingCreate: false
        });
    }

    goPreviousStep = () => {
        const newStep = this.state.currentStep - 1;
        const quantities = new Map();
        const essentials = new Map();

        this.setState({
            currentStep: newStep, 
            selectedItems: [],
            productItemsQuantity: quantities,
            productItemsEssential: essentials
        });
    }

    validateProductItems = () => {
        const instructions = this.state.productInstructions;
        const productItems = this.state.selectedItems;
        const itemQuantities = this.state.productItemsQuantity;
        const itemEssentials = this.state.productItemsEssential;

        var instructionsValidation = true;
        var itemValidation = true;
        var essentialValidation = 0;

        productItems.forEach( item => {
            if (itemQuantities[item] <= 0) {
                itemValidation = false;
            }

            if (itemEssentials[item] === true) {
                essentialValidation++;
            }
        });

        if (instructions.length <= 0) {
            instructionsValidation = false;
        }

        if (essentialValidation <= 0) {
            itemValidation = false;
        }

        this.setState({disableCreateButton: !(itemValidation && instructionsValidation)});
    }

    createProduct = (event) => {
        event.preventDefault();
        
        this.setState({loadingCreate: true});

        var productItems = [];

        const items = this.state.selectedItems;
        const quantities = this.state.productItemsQuantity;
        const essentials = this.state.productItemsEssential;
        items.forEach( item => {
            productItems.push({
                itemId: item,
                quantity: quantities[item],
                isEssential: essentials[item]
            });
        });

        API.post('benackoAPI', '/products', {
                body: {
                    companyId: this.props.companyId,
                    name: this.state.productName,
                    instructions: this.state.productInstructions,
                    items: productItems,
                    hotels: this.state.hotels
                },
                headers: {
                    Authorization: this.idToken
                }
            })
            .catch( errProduct => {
                console.log('Error storing product:', errProduct);
            });

        this.setState({loadingCreate: false});
        
        this.props.history.goBack();
    }

    render() {

        const stepOne = (
            <Spin spinning={this.state.loadingStepOne} size="large">
                <Row style={{width: 600}}>
                    <Input style={{width: '100%'}} onChange={this.setProductName} placeholder="Nombre del producto" />
                    <Select
                        mode="multiple"
                        style={{width: '100%', marginTop: 30}}
                        placeholder="Selecciona los artículos del producto"
                        onChange={this.selectItemHandler}
                    >
                        {this.state.items}
                    </Select>
                </Row>
                <Row style={{ marginTop: 50 }}>
                    <Button type="primary" onClick={this.goToSecondStep} disabled={(this.state.selectedItems.length <= 0 || !this.state.productName) ? true : false}>Siguiente</Button>
                </Row>
            </Spin>
        );

        const stepTwo = (
            <Spin spinning={this.state.loadingStepTwo} size="large">
                <Row style={{width: 600}}>
                    <TextArea
                        rows={4}
                        placeholder="Instrucciones de preparación"
                        onChange={ instructions => {
                            const beautifiesInstructions = instructions.target.value.trim().toLowerCase();
                            this.setState({productInstructions: beautifiesInstructions})
                        }} />
                </Row>
                <Row style={{width: 600, marginTop: 50, marginBottom: 10}}>
                    <Col span={6} offset={2}><strong>Artículo</strong></Col>
                    <Col span={4}><strong>Cantidad</strong></Col>
                    <Col span={6}><strong>¿Es esencial?</strong></Col>
                </Row>
                <Row style={{width: 600}}>
                    {this.state.tableItems}
                </Row>
                <Row style={{ marginTop: 40 }}>
                    <ButtonGroup>
                        <Button type="primary" onClick={this.goPreviousStep}>Regresar</Button>
                        <Button type="primary" onClick={this.validateProductItems}>Validar</Button>
                        <Button type="default" onClick={this.createProduct} disabled={this.state.disableCreateButton}>Crear</Button>
                    </ButtonGroup>
                </Row>
            </Spin>
        );

        let renderedStep = null;
        if (this.state.currentStep === 0) {
            renderedStep = stepOne;
        }

        if (this.state.currentStep === 1) {
            renderedStep = stepTwo;
        }
        
        return (
            <Layout>
                <Header style={{ background: '#fff', padding: 0 }}>
                    <Row>
                        <ButtonGroup>
                            <Button type="primary" onClick={this.goBackHandler}>
                                <LeftOutlined />Regresar
                            </Button>
                        </ButtonGroup>
                    </Row>
                </Header>
                <Content style={{width: '100%', margin: 0, padding: 0, background: '#fff', paddingTop: 15, paddingLeft: 20}}>
                    <Steps size="small" current={this.state.currentStep}>
                        <Step title="Información general" />
                        <Step title="Ingredientes" />
                    </Steps>
                    <Row style={{width: 600, marginTop: 50}}>
                        <Spin spinning={this.state.loadingCreate} size="large">
                        <Col span={20} offset={2}>
                            {renderedStep}
                        </Col>
                        </Spin>
                    </Row>
                </Content>
            </Layout>
        );
    }
}

const mapStateToProps = state => {
    return {
        hotels: state.auth.hotels,
        companyId: state.auth.companyId
    };
};


export default connect(mapStateToProps, null)(Create);